.pageSectionHeader {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px 0px;
}

.issuesExceptionsSeparator {
	margin-top: 20px;
	margin-bottom: 20px;
}